<app-header *ngIf="mostrarPlantilla"> </app-header>
<app-menu *ngIf="mostrarPlantilla"> </app-menu>
<div class="container-fluid zoom">
    <!-- id="mycontainer" -->
    <div *ngIf="usuarioLogeado"
         [ngClass]="esPortalCompras ? 'container-fluid' : 'container'">
        <router-outlet></router-outlet>
    </div>
</div>
<app-footer *ngIf="mostrarPlantilla" padding class="footer"></app-footer>
<app-chatbot-widget *ngIf="mostrarPlantilla && usuarioLogeado && tieneAccesoChatbot"></app-chatbot-widget>
